import { render, staticRenderFns } from "./OrderParticipantsCard.vue?vue&type=template&id=36affe47"
import script from "./OrderParticipantsCard.vue?vue&type=script&lang=js"
export * from "./OrderParticipantsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports